import { useContext, useEffect, useState } from 'react';

import { Popover } from 'antd';
import Cookies from 'js-cookie';
import { throttle } from 'lodash-es';
import dynamic from 'next/dynamic';

import SvgIcon from '@/components/SvgIcon';
import BottomAdContext from '@/context/BottomAdContext';
import useUserStore from '@/store/user';
import { buriedPoint } from '@/utils/buriedPoint';
import Domains from '@/utils/domains';
import sendAxios from '@/utils/request';
import Utils from '@/utils/Utils';

const DynamicCusServicePopComponent = dynamic(() => import('./components/CusServicePop'));
const DynamicXmtPopComponent = dynamic(() => import('./components/XmtPop'));
const DynamicFeedbackPopComponent = dynamic(() => import('./components/FeedbackPop'));

// 公用埋点
function headBuriedPoint(op, href, ty) {
  const current_h = window.location.href;
  if (href) {
    buriedPoint({
      cp: 'top_header',
      ty: ty || 'click',
      op: op,
      data: { hf: href, current_href: current_h },
    });
  } else {
    buriedPoint({ cp: 'top_header', ty: ty || 'click', op: op });
  }
}

function Toolbar(props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [toTopVisible, setToTopVisible] = useState(false);
  const [qrCodeSrc, setQrCodeSrc] = useState('');
  const userInfo = useUserStore((state) => state.userInfo);
  const { animateShow, setAnimateShow } = useContext(BottomAdContext);
  const { commonConfigVO, updateCommonConfigVO } = useUserStore();
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const scrollThreshold = 350; // 设置滚动阈值为 350px
  // 滚动事件处理函数
  const toggleVisibility = () => {
    if (window.scrollY > scrollThreshold) {
      setToTopVisible(true);
    } else {
      setToTopVisible(false);
    }
  };

  useEffect(() => {
    const handleScroll = throttle(toggleVisibility, 200); // 每 200ms 触发一次
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function salesInit() {
    //获取业务员代号
    if (Utils.isLogined()) {
      Cookies.set('cookies_save_operation_code_mark', '', {
        expires: 10,
        domain: '.szlcsc.com',
        path: '/',
        secure: true,
        httpOnly: false,
      });
    } else {
      const saleCode = Utils.getUrlParam('c');
      if (saleCode) {
        Cookies.set('cookies_save_operation_code_mark', saleCode, {
          expires: 10,
          domain: '.szlcsc.com',
          path: '/',
          secure: true,
          httpOnly: false,
        });
      }
    }

    sendAxios({
      method: 'get',
      url: '/v2/sale',
      baseURL: Domains.lcscMemberUrl,
    }).then(async ({ code, result }) => {
      if (code === 200) {
        //刷新侧边 客服、电话
        if (result.salesmanVO) {
          //刷新侧边qq号
          updateCommonConfigVO({
            ...commonConfigVO,
            salesmanVO: result.salesmanVO,
          });
        }
        if (result.salesmanQrCode) {
          setQrCodeSrc(result.salesmanQrCode);
        }
      }
    });
  }

  useEffect(() => {
    salesInit();
  }, []);

  useEffect(() => {
    let tId;
    if (animateShow) {
      tId = setTimeout(() => {
        setAnimateShow(false);
      }, 2130);
    }
    return () => {
      if (tId) {
        clearTimeout(tId);
      }
    };
  }, [animateShow]);

  function handleShowPop(e, op) {
    if (e) {
      headBuriedPoint(op, '', 'enter');
    }
  }

  function toTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (typeof props?.wrapToTop === 'function') {
      props?.wrapToTop();
    }
  }

  const rpgClassName =
    'block w-[1100px] h-[1200px] fixed bg-[url(//static.szlcsc.com/ecp/assets/web/common/images/activity-fixed-bottom.gif)] bg-no-repeat right-[-500px] mt-[-400px] scale-[0.6] red-package-gif rpg-block';

  return (
    <aside data-spm="cbl">
      {/* 工具栏 */}
      <div
        className={`fixed top-[50%] translate-y-[-50%] right-[-56px] z-[1000] flex flex-col justify-center items-center pb-[74px] transition-all duration-300 ease-in-out ${isExpanded ? '!right-0' : ''}`}
      >
        {userInfo?.existSendOrder || false ? (
          <a
            className="inline-block size-[54px] mb-[9px] bg-[url(https://static.szlcsc.com/ecp/assets/web/layout/tools/images/yqyl.gif)] bg-cover"
            href={Domains.lcscActivityUrl + '/invite/info.html?from=Rdh'}
            target="_blank"
            title="邀请有礼"
            data-spm="yq"
          >
            {animateShow && <div className={rpgClassName}></div>}
          </a>
        ) : (
          <a
            className="inline-block size-[54px] mb-[9px] bg-[url(https://static.szlcsc.com/ecp/assets/web/layout/tools/images/xrfl.gif)] bg-cover"
            href={Domains.lcscActivityUrl + '/newuser.html?from=Rdh'}
            target="_blank"
            title="新人福利"
            data-spm="xr"
          >
            {animateShow && <div className={rpgClassName}></div>}
          </a>
        )}
        <ul className="list-none flex flex-col p-[5px_4px] items-center text-[12px] bg-white rounded-[12px_0px_0px_12px] shadow-[0px_4px_8px_0px_rgba(11,791,119,0.07)]">
          <Popover
            overlayClassName="lcsc-popover-wrapper"
            content={<DynamicCusServicePopComponent qrCodeSrc={qrCodeSrc} headBuriedPoint={headBuriedPoint} />}
            placement="leftTop"
            overlayInnerStyle={{ padding: 0 }}
            onOpenChange={(e) => handleShowPop(e, 'kf')}
            getPopupContainer={(node) => node.parentElement}
          >
            <li className="size-[48px] cursor-pointer text-center hover:bg-[#F5F5F5] hover:rounded-[8px]">
              <SvgIcon app="common" iconName="lxkf" className="mx-auto size-[24px] mt-[6px]" />
              <p className="mt-[2px] leading-[16px]">客服</p>
            </li>
          </Popover>
          <Popover
            getPopupContainer={(node) => node.parentElement}
            overlayClassName="lcsc-popover-wrapper min-w-[154px]"
            content={<DynamicXmtPopComponent />}
            placement="leftTop"
            overlayInnerStyle={{ padding: 0 }}
            onOpenChange={(e) => handleShowPop(e, 'public_account_qr')}
          >
            <li className="mt-[15px] mb-[12px] size-[48px] cursor-pointer text-center hover:bg-[#F5F5F5] hover:rounded-[8px]">
              <SvgIcon app="common" iconName="xinmeiti" className="mx-auto size-[22px] mt-[6px]" />
              <p className="mt-[2px] leading-[16px]">芯媒体</p>
            </li>
          </Popover>
          <Popover
            getPopupContainer={(node) => node.parentElement}
            overlayClassName="lcsc-popover-wrapper"
            content={<DynamicFeedbackPopComponent onClose={() => setIsFeedbackOpen(false)} />}
            placement="leftTop"
            overlayInnerStyle={{ padding: 0 }}
            trigger={'click'}
            open={isFeedbackOpen}
            onOpenChange={(e) => setIsFeedbackOpen(e)}
          >
            <li
              className="size-[48px] cursor-pointer text-center hover:rounded-[8px] hover:bg-[#F5F5F5]"
              onClick={() => setIsFeedbackOpen(true)}
            >
              <SvgIcon app="common" iconName="yijian" className="mx-auto mt-[6px] size-[20px]" />
              <p className="mt-[2px] leading-[16px]">反馈</p>
            </li>
          </Popover>
        </ul>
        <div className="w-[56px] h-[116px] rounded-[9px_0px_0px_9px] relative">
          <ul className="absolute mt-[22px] p-[4px] text-[12px] text-[#666666] bg-[white] rounded-[9px_0px_0px_9px] shadow-[0px_4px_8px_0px_rgba(11,791,119,0.07)]">
            <li
              className="size-[48px] hover:bg-[#F5F5F5] hover:rounded-[8px] text-center flex items-center flex-wrap cursor-pointer"
              onClick={toggleExpansion}
            >
              <SvgIcon app="common" iconName="close" className="mx-auto w-[9px] h-[16px] mb-[4px] mt-[7px]" />
              <p className="w-full">收起</p>
            </li>
            <li
              onClick={toTop}
              className={`size-[48px] hover:bg-[#F5F5F5] hover:rounded-[8px] text-center flex items-center
                flex-wrap cursor-pointer mt-[11px] ${toTopVisible ? 'block' : 'hidden'}`}
            >
              <SvgIcon app="common" iconName="top" className="mx-auto w-[17px] h-[10px] mb-[4px] mt-[7px]" />
              <p className="w-full">置顶</p>
            </li>
          </ul>
        </div>
      </div>
      {/* 展开按钮 */}
      <button
        className={`bg-white fixed top-[50%] translate-y-[-50%] right-[-46px] rounded-[10px_0px_0px_10px] shadow-[0px_4px_8px_0px_rgba(11,791,119,0.07)]
          transition-all duration-300 ease-in-out w-[32px] h-[107px] z-[1000] ${isExpanded ? '' : '!right-0'}`}
        onClick={toggleExpansion}
      >
        <SvgIcon app="common" iconName="open" className="mx-auto w-[16px] h-[16px] mb-[3px]" />
        <span className="text-[#666666] text-[12px]" style={{ writingMode: 'vertical-rl', letterSpacing: '4px' }}>
          展开客服
        </span>
      </button>
    </aside>
  );
}

export default Toolbar;
